import { createStore } from '@stencil/store';
import { GalleryModalState } from 'types';
import { changeOverflowBody } from 'utils/ui';
import initParams from './initParams';

const { state, onChange, reset } = createStore<GalleryModalState>({
  images: [],
  isOpen: false,
});

onChange('isOpen', newValue => {
  changeOverflowBody(newValue, initParams.isApp);
});

window.document.addEventListener('reset-chat-stores', () => {
  reset();
});

export default state;
